import React from 'react';
import { Translate } from 'react-redux-i18n';
import CampaignOrganizerInput from '../../campaignOrganizers/input/CampaignOrganizerInput';

const CreateCampaignOrganizerContent = () => (
  <>
    <h2>
      <Translate value='campaignOrganizers.page.create.title' />
    </h2>
    <CampaignOrganizerInput mode='create' />
  </>
);

export default CreateCampaignOrganizerContent;
